import React, { useEffect, useState, useContext } from "react";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import { Modal, Space, Button } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import {
  disabledDate,
  getLocalizedMessage,
} from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { AUDIT_STATUSES, currentAuditType, userRole } from "../../constants";
import { Text } from "react_reusable_components";
import Style from "./UpdateTmModal.module.scss";

import AuditService from "../../services/audit-service";

const BlockUserModalStyles = {
  changed: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
  },
  changedSuccess: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
    textAlign: variables.alignCenter,
    color: variables.textDefault,
    lineHeight: variables.lineHeightXxlarge,
    display: variables.dBlock,
  },
  BlockButton: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    flex: 1,
  },
  CancelButton: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    flex: 1,
    border: `1px solid ${variables.grey4}`,
  },
  modalContent: {
    all: variables.unset,
    width: variables.fullWidth,
  },
  modalMaskStyle: {
    backdropFilter: variables.highBlur,
    background: variables.blurBackground,
  },
  btnContainer: { display: variables.dFlex, gap: variables.gapSmall },
  textarea: {
    width: variables.fullWidth,
    fontSize: variables.fontSizeNormal,
  },
  centerImg: {
    display: variables.dFlex,
    justifyContent: variables.alignCenter,
    position: "relative",
  },
  cross: {
    position: "absolute",
    right: "0",
    top: "0",
    height: variables.iconHeightLarge,
    width: variables.iconWidthLarge,
    cursor: "pointer",
  },
};

export default function UpdateTMModal({
  open,
  record,
  onClose,
  onSubmit,
  isReAudit,
}) {
  const [tmId, setTmId] = useState(null);
  const [tmUsersList, setTMUserList] = useState([]);
  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const intl = useIntl();

  useEffect(() => {
    if (record?.tm?.id) {
      setTmId(record.tm.id);
    }
  }, [record]);
  useEffect(() => {
    AuditService.getUsersList({
      loaderDispatch,
      intl,
      params: {
        roleId: userRole.TM,
      },
    }).then((data) => {
      setTMUserList(data);
    });
  }, []);

  const onFormSubmit = (e) => {
    e.preventDefault();
    const values = {
      tm_id: tmId,
    };
    onSubmit(values);
  };
  return (
    <Modal
      maskClosable={false}
      maskStyle={BlockUserModalStyles.modalMaskStyle}
      centered
      open={open}
      closable={false}
      footer={null}
      width={400}
    >
      <form onSubmit={onFormSubmit}>
        <Space
          direction="vertical"
          align="center"
          style={BlockUserModalStyles.modalContent}
        >
          <div style={BlockUserModalStyles.centerImg}>
            <img
              style={BlockUserModalStyles.cross}
              src={"/icons/close.svg"}
              alt="block-user"
              onClick={onClose}
            />
          </div>
          <CustomSelect
            required
            label={getLocalizedMessage(intl, "auditListing.modal.selectTM")}
            placeholder={getLocalizedMessage(
              intl,
              "auditListing.modal.selectTM"
            )}
            onChange={(e) => {
              setTmId(e);
            }}
            value={tmId || null}
            options={tmUsersList?.map(({ name, id, isActive }) => {
              return {
                label: (
                  <Text
                    className={`${Style["select-item-style"]} ${
                      !isActive && Style["low-opacity"]
                    }`}
                  >
                    {name}
                  </Text>
                ),
                value: id,
                name,
                disabled: !isActive,
              };
            })}
          />
          <div style={BlockUserModalStyles.btnContainer}>
            <Button
              style={BlockUserModalStyles.CancelButton}
              icon={null}
              type="text"
              onClick={onClose}
            >
              {getLocalizedMessage(intl, "button.text.cancel")}
            </Button>
            <Button
              style={{
                ...BlockUserModalStyles.BlockButton,
                ...{
                  backgroundColor: tmId && variables.successGreen,
                },
              }}
              icon={null}
              htmlType="submit"
              disabled={!tmId}
            >
              {getLocalizedMessage(intl, "button.text.update")}
            </Button>
          </div>
        </Space>
      </form>
    </Modal>
  );
}
